<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="contacts">
            <van-loading
                class="pageLogin"
                v-if="isloading"
                type="spinner"
                color="#1989fa"
            ></van-loading>
            <van-nav-bar
                title="联系人"
                left-text="添加"
                left-arrow
                @click-left="onClickLeft"
            >
                <van-icon name="filter-o" slot="right" @click="showPopup"></van-icon>
            </van-nav-bar>
            <div class="noData" v-if="contactsData.length<1"></div>
            <section v-else>
                <van-search v-model="value" placeholder="请输入搜索信息" @change="search"></van-search>
                <div class="list van-pull-refresh">
                    <dl>
                        <dd>
                            <van-index-bar :index-list="indexList" :sticky="false">
                                <template v-for="(item, index) in contactsData">
                                    <van-index-anchor :index="item.Initial" :key="index"></van-index-anchor>
                                    <template v-for="(k, i) in item.data">
                                        <van-cell :key="i" @click="openContactInfo(k.User_Id)">
                                            <img class="van_left" src="@/assets/images/addressBook/icon_group_1@2x.png" alt="头像">
                                            <div class="van_left info">
                                                <p>{{ k.User_Name }}</p>
                                                <span>{{ k.Dept_Name }}</span>
                                            </div>
                                        </van-cell>
                                    </template>
                                </template>
                            </van-index-bar>
                        </dd>
                    </dl>
                </div>
                <van-popup
                    class="sideslip"
                    v-model="show"
                    position="right"
                    :style="{ width: '80%',height: '100%' }"
                >
                    <van-nav-bar
                        title="筛选"
                        right-text="取消"
                        @click-right="onClickRight"
                    >
                    </van-nav-bar>
                    <section>
                        <dl>
                            <dt>所属部门</dt>
                            <dd>
                                <template v-for="(item, index) in organizeData">
                                    <p :class="{'active': item.active}" :key="index" @click="selectOrganize(item)">
                                        {{ item.org_name }}
                                    </p>
                                </template>
                            </dd>
                        </dl>
                    </section>
                    <footer>
                        <button @click="confirmSelect">
                            确定
                        </button>
                        <button @click="resetSelect">
                            重置
                        </button>
                    </footer>
                </van-popup>
            </section>
        </div>
    </v-touch>
</template>

<script>

export default {
    // 联系人
    name: 'contacts',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/addContact') {
            this.$store.commit('noKeepAlive', 'contacts');
        }
        next();
    },
    props: {},
    data() {
        return {
            // 加载中状态
            isloading: false,
            // 筛选层状态
            show: false,
            // 搜索框内容
            value: '',
            // 联系人数据集合
            contactsData: [],
            // 组织数据
            organizeData: [],
            // 选择组织数据
            selectOrganizeData: '',
            // 索引数组
            indexList: [],
        };
    },
    computed: {},
    watch: {},
    created() {
        // 获取联系人数据
        this.gitcontactsData();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 返回上级页面
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 打开联系人信息页
        openContactInfo(id) {
            this.$router.isBack = 2;
            this.$router.push({ path: '/contactInfo', query: { User_Id: id } });
        },
        // 打开筛选层
        showPopup() {
            this.show = true;
        },
        // 关闭筛选层
        onClickRight() {
            this.show = false;
        },
        // 获取联系人数据
        gitcontactsData() {
            this.isloading = true;
            this.$axios
                .get('/interfaceApi/basicplatform/deptusers/all/' + this.$route.query.id + '?page=1&rows=9999')
                .then(res => {
                    if (res.List.length > 0) {
                        // 处理数据
                        const newData = this.$dataSorting(res.List, 'User_Name');
                        // 常用联系人数据赋值
                        this.contactsData = newData.dataList;
                        // 索引数组赋值
                        this.indexList = newData.indexList;
                    } else {
                        this.contactsData = [];
                    }
                    this.isloading = false;
                    // 获取联系人信息
                    this.gitOrganizeData();
                }).catch(error => {
                    this.isloading = false;
                    this.$dialog({ message: error });
                });
        },
        // 获取过滤部门数据
        gitOrganizeData() {
            this.$axios
                .get('/interfaceApi/basicplatform/orgtree/child/org/' + this.$route.query.id + '/2')
                .then(res => {
                    res.forEach(element => {
                        element.active = false;
                    });
                    this.organizeData = res;
                }).catch(error => {
                    this.$dialog({ message: error });
                });
        },
        // 选择部门
        selectOrganize(data) {
            data.active = !data.active;
            if (this.selectOrganizeData === '') {
                this.selectOrganizeData = data.id;
            } else {
                this.selectOrganizeData += ',' + data.id;
            }
        },
        // 确认选择部门
        confirmSelect() {
            if (this.selectOrganizeData === '') {return;}
            this.show = false;
            this.isloading = true;
            this.$axios
                .get('/interfaceApi/basicplatform/deptusers/roles/' + this.selectOrganizeData)
                .then(res => {
                    if (res.List.length > 0) {
                        // 处理数据
                        const newData = this.$dataSorting(res.List, 'User_Name');
                        // 常用联系人数据赋值
                        this.contactsData = newData.dataList;
                        // 索引数组赋值
                        this.indexList = newData.indexList;
                    } else {
                        this.contactsData = [];
                    }
                    this.isloading = false;
                }).catch(error => {
                    this.$dialog({ message: error });
                });
        },
        // 重置选择部门
        resetSelect() {
            this.organizeData.forEach(element => {
                element.active = false;
                this.selectOrganizeData = '';
            });
            this.gitcontactsData();
        },
        // 头部搜索
        search() {
            if (this.value === '') {
                this.gitcontactsData();
            } else {
                const searchContactsData = [];
                this.contactsData.forEach(item => {
                    item.data.forEach(k => {
                        if (k.User_Name.indexOf(this.value) !== -1 || k.Initials.indexOf(this.value) !== -1) {
                            searchContactsData.push(k);
                        }
                    });
                });
                // 处理数据
                const newData = this.$dataSorting(searchContactsData, 'User_Name');
                // 常用联系人数据赋值
                this.contactsData = newData.dataList;
                // 索引数组赋值
                this.indexList = newData.indexList;
            }
        },
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
    },
};
</script>
<style lang="stylus">
.contacts
    height 100%
    .noData
        height calc(100% - 44rpx)
        width 100%
        background url(./../../../assets/images/addressBook/no_contacs@2x.png) center no-repeat
        background-size 100%
    section
        height calc(100% - 44rpx)
        .list
            height calc(100% - 44rpx)
            overflow-y auto
            dl
                overflow hidden
            dd
                border-bottom 1px solid #F0F0F0
            dd
                .van-cell
                    height 60rpx
                    padding 10rpx 15rpx
                    &:after
                        left 0
                    img
                        width 40rpx
                        height 40rpx
                        margin-right 10rpx
                    .info
                        width calc(100% - 50rpx)
                        p,span
                            width 100%
                            float left
                        p
                            font-size 18rpx
                            line-height 20rpx
                            color #333333
                            margin-bottom 8rpx
                        span
                            font-size 12rpx
                            line-height 12rpx
                            color #979EA7
                .van-index-anchor
                    font-size 12rpx
                    line-height 20rpx
                    background #F9F9F9
</style>